// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"433":"cad63971","742":"8efc056c","924":"45fba7da"}[chunkId] + ".chunk.css";
};